import { Box, Grid, Tab, Tabs, TextField, Typography } from "@mui/material";
import useStyles from "./confirmationStyle";
import { confirmationDetails } from "./confirmationUtils";
import FormField from "../../../components/common/FormField";
import React, { useState } from "react";

const ConfirmationDetails = ({ formData }: { formData: any }) => {
  const classes = useStyles();
console.log("formData in confirmation details-", formData);
  const [collectionTab, setCollectionTab] = useState(0);
  const [deliveryTab, setDeliveryTab] = useState(0);

  const collectionList = formData?.collectFrom || [];
  const deliveryList = formData?.deliveryTo || [];

  const labels = [
    "Pace: Dwelling to Vehicles",
    "External Flight of Stairs",
    // "Property Style",
    "Bedrooms",
    "Levels",
    "Purchase Status",
  ];

  const getDetailRows = (data: any) => [
    data?.paces ?? 0,
    data?.flight_of_stairs ?? 0,
    // data?.type ?? 0,
    // data?.bedrooms ?? 0,
    data?.house_size ?? 0,
    data?.floors ?? 0,
    data?.purchase_status ?? "N/A",
  ];

  // Helper functions to get formatted address
  const getCollectionAddress = (index: number) => {
    const addr = collectionList[index] || {};
    const parts = [addr?.street, addr?.county, addr?.country, addr?.postcode];
    return parts.filter(Boolean).join(", ");
  };

  const getDeliveryAddress = (index: number) => {
    const addr = deliveryList[index] || {};
    const parts = [
      addr?.street,
      addr?.town,
      addr?.county,
      addr?.country,
      addr?.postcode,
    ];
    return parts.filter(Boolean).join(", ");
  };

  return (
    <>
      {/* === TABS ON TOP === */}
      {(collectionList.length > 0 || deliveryList.length > 0) && (
        <Grid
          container
          spacing={2}
          display={"flex"}
          justifyContent="space-between"
          sx={{ marginBottom: "0px" }}
        >
          <Grid item xs={4} sx={{ padding: "0px !important" }}>
            {collectionList.length >= 0 && (
              <Tabs
                value={collectionTab}
                onChange={(_, val) => setCollectionTab(val)}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: {
                    height: 2, // Indicator thickness
                  },
                }}
                sx={{
                  minHeight: 30, // Reduce Tabs container height
                  ".MuiTab-root": {
                    minHeight: 30, // Reduce Tab height
                  },
                }}
              >
                {collectionList.map((_: any, i: number) => (
                  <Tab
                    sx={{ fontSize: "12px", fontWeight: 600 }}
                    label={`Collection ${i + 1}`}
                    key={i}
                  />
                ))}
              </Tabs>
            )}
          </Grid>
          <Grid item xs={4} sx={{ padding: "0px !important" }}>
            <Box
              sx={{
                border: "1px solid #ccc",
                borderRadius: "6px",
                padding: "6px 8px",
                backgroundColor: "#fafafa",
                minHeight: "40px",
                height: "40px",
                fontSize: "14px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                //   textWrap: "wrap",
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  color: "gray",
                  marginBottom: "4px",
                  textAlign: "center",
                  fontWeight: 700,
                  fontSize: 14,
                }}
              >
                Name:- {formData?.name}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{ padding: "0px !important", paddingLeft: "6px !important" }}
          >
            {deliveryList.length >= 0 && (
              <Tabs
                value={deliveryTab}
                onChange={(_, val) => setDeliveryTab(val)}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: {
                    height: 2, // Indicator thickness
                  },
                }}
                sx={{
                  minHeight: 30, // Reduce Tabs container height
                  ".MuiTab-root": {
                    minHeight: 30, // Reduce Tab height
                  },
                }}
              >
                {deliveryList.map((_: any, i: number) => (
                  <Tab
                    sx={{ fontSize: "12px", fontWeight: 600 }}
                    label={`Delivery ${i + 1}`}
                    key={i}
                  />
                ))}
              </Tabs>
            )}
          </Grid>
        </Grid>
      )}

      {/* === Name and Address Fields === */}
      <Grid
        container
        spacing={0.5}
        sx={{ paddingLeft: "0px", marginTop: "0px" }}
      >
        {confirmationDetails.map((field) => {
          let value = formData?.[field.id] || "";

          if (field.id === "collectFrom") {
            value = getCollectionAddress(collectionTab);
          } else if (field.id === "deliveryTo") {
            value = getDeliveryAddress(deliveryTab);
          }

          return (
            <Grid
              item
              xs={4}
              sx={{ paddingLeft: "0px !important" }}
              key={field.id}
            >
              <Box
                sx={{
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  padding: "6px 8px",
                  backgroundColor: "#fafafa",
                  minHeight: "40px",
                  height: "stretch",
                  fontSize: "14px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  //   textWrap: "wrap",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    color: "gray",
                    marginBottom: "4px",
                    textAlign: "center",
                    fontWeight: 700,
                    fontSize: 14,
                  }}
                >
                  {field.label}
                </Typography>
                {field.id !== "details" && (
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {value || "--"}
                  </Typography>
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>

      {/* === Details Section === */}
      <Box
        style={{
          border: "2px solid #eeecef",
          borderRadius: "5px",
        }}
      >
        <Grid
          container
          spacing={2}
          sx={{ marginTop: "0px !important", marginLeft: "0px !important" }}
          alignItems="flex-start"
        >
          {/* Collection Details */}
          <Grid
            item
            xs={4}
            sx={{ marginLeft: "0px !important", paddingTop: "0px !important" }}
          >
            {getDetailRows(collectionList[collectionTab] || {}).map(
              (val, i) => (
                <Typography sx={{ textAlign: "center" }} key={i}>
                  {val}
                </Typography>
              )
            )}
          </Grid>

          {/* Labels */}
          <Grid
            item
            xs={4}
            sx={{
              background: "#CDF9D3",
              textAlign: "center",
              borderRadius: 2,
              // marginLeft: "-8px !important",
              paddingTop: "0px !important",
            }}
          >
            {labels.map((label, i) => (
              <Typography key={i}>{label}</Typography>
            ))}
          </Grid>

          {/* Delivery Details */}
          <Grid item xs={4} sx={{ paddingTop: "0px !important" }}>
            {getDetailRows(deliveryList[deliveryTab] || {}).map((val, i) => (
              <Typography sx={{ textAlign: "center" }} key={i}>
                {val}
              </Typography>
            ))}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ConfirmationDetails;
